import React, { useState, useEffect } from 'react';
import { Table, Checkbox, Button, Row, Col, Breadcrumb, Form, Select, Modal, notification } from 'antd';
import { HeaderCell, unexpectedError } from '../../common_functions';
import { roles } from '../../config';
import { ExclamationCircleOutlined, CloseOutlined } from '@ant-design/icons';
const components = {
  header: {
    cell: HeaderCell,
  },
};
const UserRoles = props => {
  const [loading, setLoading] = useState(false);
  const [permissionsData, setpermissionsData] = useState([]);
  const [roleID, setRoleID] = useState(roles.collection_admin);
  const [newPermissionsData, setNewPermissionsData] = useState([]);
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    (async () => {
    await getRolesData();
  })();
  }, []);
  const getRolesData = async id => {
    setLoading(true);
    try {
      let { data } = await props.getRolesPermissions(id || roleID);
      setpermissionsData(data);
      setNewPermissionsData(data);
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      title: 'Entities',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <span
          style={{
            textTransform: 'capitalize',
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: 'Create',
      dataIndex: 'create',
      key: 'create',
      render: (text, record) => (
        <span>
          <Checkbox checked={!!text} onChange={e => managePermissions(e, record.e_id, 'create')} />
        </span>
      ),
    },
    {
      title: 'Read',
      dataIndex: 'view',
      key: 'view',
      render: (text, record) => (
        <span>
          <Checkbox checked={!!text} onChange={e => managePermissions(e, record.e_id, 'view')} />
        </span>
      ),
    },
    {
      title: 'Edit',
      dataIndex: 'edit',
      key: 'edit',
      render: (text, record) => (
        <span>
          <Checkbox checked={!!text} onChange={e => managePermissions(e, record.e_id, 'edit')} />
        </span>
      ),
    },
    {
      title: 'Delete',
      dataIndex: 'delete',
      key: 'delete',
      render: (text, record) => (
        <span>
          {record.name === 'settings - configuration' ? (
            <Checkbox disabled />
          ) : (
            <Checkbox checked={!!text} onChange={e => managePermissions(e, record.e_id, 'delete')} />
          )}
        </span>
      ),
    },
    {
      title: 'All',
      dataIndex: 'all',
      key: 'all',
      render: (text, record) => (
        <span>
          {record.name === 'settings - configuration' ? (
            <Checkbox disabled />
          ) : (
            <Checkbox checked={!!text} onChange={e => managePermissions(e, record.e_id, 'all')} />
          )}
        </span>
      ),
    },
  ];

  const managePermissions = (event, entity_id, permission) => {
    setDisabled(false);
    let checked = event.target.checked;
    let permissionObj = setPermissionsChanges(permission, checked);
    let newData = newPermissionsData.map(obj => {
      if (obj.e_id == entity_id) {
        obj = {
          ...obj,
          ...permissionObj,
        };
        // if create, view, edit, delete checked then "all" checked
        obj.all = obj.view && obj.edit && obj.delete && obj.create;

        if (obj.name === 'settings - configuration') {
          obj.delete = false;
          obj.all = false;
        }
      }
      return { ...obj, entities: obj.e_id, role_id: roleID };
    });
    setNewPermissionsData(newData);
  };
  const setPermissionsChanges = (permission, checked) => {
    switch (permission) {
      case 'all':
        return {
          all: checked,
          view: checked,
          edit: checked,
          delete: checked,
          create: checked,
        };
      case 'view':
        return !!checked
          ? { view: checked }
          : {
              create: checked,
              view: checked,
              edit: checked,
              all: checked,
              delete: checked,
            };
      case 'edit':
        return !!checked ? { edit: checked, view: checked } : { edit: checked, all: checked };
      case 'create':
        return !!checked ? { create: checked, view: checked } : { create: checked, all: checked };
      case 'delete':
        return !!checked ? { delete: checked, view: checked } : { delete: checked, all: checked };
      default:
        return {};
    }
  };
  const changeUsersPermissionConfirmation = async values => {
    return Modal.confirm({
      title: 'Confirmation',
      className: 'custom_modal',
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          <p>
            {' '}
            Do you want to apply these new permission changes to linked users? If yes, please click the "Save" button to store the
            permissions for both roles and associated users.
          </p>
          <div className="custom_button">
            <Button onClick={() => onFinish(false)}>Save for role</Button>
            <Button type="primary" onClick={() => onFinish(true)}>
              Save
            </Button>
          </div>
        </div>
      ),
      closable: true,
      closeIcon: <Button className="ant-modal-close-x" type="link" icon={<CloseOutlined />} />,
      okButtonProps: { style: { display: 'none' } }, // Hide the OK button
      cancelButtonProps: { style: { display: 'none' } }, //inish(true);
    });
  };

  const onFinish = async (saveForUsers = false) => {
    Modal.destroyAll();
    setLoading(true);
    try {
      let { data } = await props.saveBatchRolesPermissions(roleID, permissionsData, newPermissionsData, saveForUsers);
      setDisabled(true);
      notification['success']({
        message: 'Permissions saved successfully!',
        duration: 2,
      });
      setNewPermissionsData(data);
      setpermissionsData(data);
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Roles Permissions" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Form layout="vertical">
            <Row gutter={24}>
              <Col xs={24} sm={8} md={8} lg={8}>
                <Form.Item label="Roles">
                  <Select
                    placeholder="Select Role"
                    optionFilterProp="children"
                    style={{
                      textTransform: 'capitalize',
                    }}
                    onChange={e => {
                      setRoleID(e);
                      getRolesData(e);
                    }}
                    defaultValue={roles.collection_admin}
                  >
                    {Object.entries(roles).map(
                      ([key, value]) => value != roles.admin && <Select.Option key={value} value={value}>{key.replaceAll('_', ' ')}</Select.Option>
                    )}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <hr />
          <div className="artist-list">
            <Table
              className="no-fixed-last-col"
              scroll={{ x: 'max-content' }}
              columns={columns}
              dataSource={newPermissionsData}
              components={components}
              bordered
              rowKey={record => record.e_id}
              pagination={false}
              loading={loading}
            />
            <Row gutter={24} className="page-header-section" align="middle" style={{ marginTop: '20px' }}>
              <Col xs={12}>
                <Button
                  disabled={isDisabled}
                  className="save-btn"
                  type="primary"
                  style={{ margin: '0 8px' }}
                  htmlType="button"
                  // onClick={() =>
                  //   confirmationModal(
                  //     'values',
                  //     'Confirmation',
                  //     'Do you want to apply these new permission changes to linked users? If yes, please click the "Save" button to store the permissions for both roles and associated users.',
                  //     "Save for roles",
                  //     "Save",
                  //     handleSave,
                  //     handleOk
                  //   )
                  // }
                  onClick={changeUsersPermissionConfirmation}
                >
                  Save Permissions
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default UserRoles;
